export enum LoadingStep {
  VERIFYING_PRICE_CHANGE = "VERIFYING_PRICE_CHANGE",
  VERIFYING_PAYMENT = "VERIFYING_PAYMENT",
  FINALIZING_ORDER = "FINALIZING_ORDER"
}

export type State = {
  currentStep: LoadingStep | null;
  loadingStepsEnabled: boolean;
};

export const getInitialState = (): State => ({
  currentStep: null,
  loadingStepsEnabled: false
});
